import { useState } from 'react';
import { Button, Flex, Modal, Text } from '@mantine/core';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	isLoading: boolean;
	onConfirm: () => void;
}

/**
 * Withdraws a form the investor uploaded but has not signed. Behind a confirmation because the
 * upload is discarded — they download and fill the blank form again. The dialog stays open while
 * the removal is in flight; the row it belongs to disappears once the form is back to unsubmitted.
 */
export const RemoveSubmittedFormAction = ({ isLoading, onConfirm }: Props) => {
	const tInvestor = useTranslationInvestor();
	const [isConfirmOpen, setIsConfirmOpen] = useState(false);

	return (
		<>
			<Button
				size="md"
				variant="subtle"
				color="red"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					setIsConfirmOpen(true);
				}}
			>
				{tInvestor('investment.contracts.signableFormModal.remove_form')}
			</Button>
			<Modal
				opened={isConfirmOpen}
				onClose={() => setIsConfirmOpen(false)}
				title={tInvestor('investment.contracts.signableFormModal.remove_form_title')}
				centered
			>
				<Flex direction="column" gap="md" p="md">
					<Text>
						{tInvestor(
							'investment.contracts.signableFormModal.remove_form_description'
						)}
					</Text>
					<Flex gap="sm" justify="flex-end">
						<Button
							variant="default"
							disabled={isLoading}
							onClick={() => setIsConfirmOpen(false)}
						>
							{tInvestor('investment.contracts.signableFormModal.remove_form_cancel')}
						</Button>
						<Button color="red" disabled={isLoading} onClick={onConfirm}>
							{tInvestor(
								'investment.contracts.signableFormModal.remove_form_confirm'
							)}
						</Button>
					</Flex>
				</Flex>
			</Modal>
		</>
	);
};
